import styled from 'styled-components';

import { Header } from 'components/header';

import { HEADER_BG_COLOR } from '../constants';

export const StyledHeader = styled(Header)`
  flex: 1 1 auto;
  background-color: ${HEADER_BG_COLOR};
`;
